<template>
  <thead>
    <tr>
      <th
        class="border-l border-r border-schneider-petrol-light sticky top-0 px-3 py-2 text-sm font-semibold text-white bg-schneider-petrol hover:bg-schneider-petrol-light hover:cursor-pointer"
        v-bind:key="s.id"
        v-for="s in columns"
        v-on:click="doSort(s.name)"
      >
        <span v-html="s.titel"></span>
      </th>
    </tr>
  </thead>
</template>

<script>
export default {
  props: {
    columns: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    doSort(name) {
      this.$emit("click", name);
    },
  },
};
</script>

<style>
</style>